import { dataService } from '../services/dataService.js';
import { seoService } from '../services/seoService.js';

export async function renderLocationsView(locationId) {
  const container = document.createElement('div');
  container.className = 'main-content';

  if (!locationId) {
    seoService.update({
      title: 'Sri Lankan Movie Filming Locations & Scenic Spots',
      description: 'Explore scenic movie filming locations across Sri Lanka featured in cinema.'
    });

    container.innerHTML = `
      <div class="section-header">
        <h1 class="section-title">Scenic Filming Locations</h1>
      </div>
      <p style="color: var(--text-secondary); margin-bottom: var(--space-lg); font-size: 0.95rem;">
        Discover the iconic landscapes, historic colonial ramparts, and mist-covered mountain peaks where Sri Lankan cinema came alive.
      </p>

      <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: var(--space-lg);">
        <a href="#/location/ella-demodara" class="movie-card clickable-item" style="flex: auto;">
          <div class="card-poster-wrap" style="aspect-ratio: 16 / 9;">
            <img src="https://images.unsplash.com/photo-1546708973-b339540b5162?auto=format&fit=crop&w=800&q=80" alt="Ella" class="card-poster" />
          </div>
          <div class="card-body">
            <h3 class="card-title">Ella & Demodara Cliffs</h3>
            <div class="card-sinhala">ඇල්ල සහ දෙමෝදර කඳුවැටිය</div>
            <div class="card-meta">Uva Province • Featured in Sinhabahu (2024)</div>
          </div>
        </a>

        <a href="#/location/galle-fort" class="movie-card clickable-item" style="flex: auto;">
          <div class="card-poster-wrap" style="aspect-ratio: 16 / 9;">
            <img src="https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?auto=format&fit=crop&w=800&q=80" alt="Galle Fort" class="card-poster" />
          </div>
          <div class="card-body">
            <h3 class="card-title">Galle Fort Ramparts</h3>
            <div class="card-sinhala">ගාල්ල කොටුව සහ වෙරළ තීරය</div>
            <div class="card-meta">Southern Province • Featured in Nidhanaya & Kandak Sema</div>
          </div>
        </a>
      </div>
    `;
    return container;
  }

  const loc = await dataService.getLocation(locationId);
  if (!loc) {
    container.innerHTML = `<div style="text-align: center; padding: var(--space-2xl) 0;"><p>Location not found.</p><a href="#/locations" class="btn-primary" style="margin-top: 16px;">Back to Locations</a></div>`;
    return container;
  }

  seoService.update({
    title: `${loc.name} Filming Location`,
    description: loc.description,
    image: loc.image
  });

  container.innerHTML = `
    <div style="margin-bottom: var(--space-lg);">
      <span class="badge-pill badge-gold" style="margin-bottom: 6px;">📍 ${loc.province}</span>
      <h1 style="font-size: 1.8rem; font-weight: 800; line-height: 1.2;">${loc.name}</h1>
      <div style="font-size: 1.1rem; color: var(--accent-gold); font-weight: 600; margin-top: 4px;">${loc.sinhalaName}</div>
      <div style="font-size: 0.82rem; color: var(--text-muted); margin-top: 4px;">GPS Coordinates: ${loc.coordinates}</div>
    </div>

    <div style="width: 100%; aspect-ratio: 16 / 9; max-height: 400px; border-radius: var(--radius-lg); overflow: hidden; margin-bottom: var(--space-xl); box-shadow: var(--shadow-lg);">
      <img src="${loc.image}" alt="${loc.name}" style="width: 100%; height: 100%; object-fit: cover;" />
    </div>

    <section style="margin-bottom: var(--space-xl);">
      <div class="section-header"><h2 class="section-title">About this Scenic Destination</h2></div>
      <p style="color: var(--text-secondary); line-height: 1.6; font-size: 0.95rem;">${loc.description}</p>
      ${loc.travelTip ? `
        <div style="margin-top: 12px; background: var(--bg-surface-elevated); border-left: 3px solid var(--accent-gold); padding: 12px 16px; border-radius: var(--radius-sm); font-size: 0.88rem; color: var(--text-primary);">
          💡 <strong>Travel Tip:</strong> ${loc.travelTip}
        </div>
      ` : ''}
    </section>

    <section style="margin-bottom: var(--space-xl);">
      <div class="section-header"><h2 class="section-title">Movies Filmed Here</h2></div>
      <div style="display: flex; flex-direction: column; gap: var(--space-xs);">
        ${(loc.associatedMovies || []).map(m => `
          <a href="#/movie/${m.movieId}" class="song-card clickable-item" style="padding: 12px 16px;">
            <div class="song-info">
              <h4 class="song-title">${m.title} (${m.year})</h4>
              <p style="font-size: 0.82rem; color: var(--text-secondary); margin-top: 2px;">${m.scenes}</p>
            </div>
            <span class="badge-pill badge-gold" style="font-size: 0.75rem;">View Movie</span>
          </a>
        `).join('')}
      </div>
    </section>
  `;

  return container;
}
